"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flows = void 0;
exports.getOnboardingSteps = getOnboardingSteps;
exports.getCurrentOnboardingStep = getCurrentOnboardingStep;
exports.getCurrentOnboardingStepForUser = getCurrentOnboardingStepForUser;
exports.getOnboardingStepAsOrdinal = getOnboardingStepAsOrdinal;
const types_1 = require("./types");
/**
 * The steps in each onboarding flow
 */
exports.flows = {
    standard: [
        types_1.OnboardingStep.enum.survey,
        types_1.OnboardingStep.enum.chooseInvites,
        types_1.OnboardingStep.enum.choosePlan,
        types_1.OnboardingStep.enum.done,
    ],
    streamlined: [types_1.OnboardingStep.enum.choosePlan, types_1.OnboardingStep.enum.done],
};
function getOnboardingSteps(flow) {
    return exports.flows[flow];
}
function getCurrentOnboardingStep(flow, completedSteps) {
    for (const step of getOnboardingSteps(flow)) {
        if (!completedSteps.has(step)) {
            return step;
        }
    }
    return types_1.OnboardingStep.enum.done;
}
function getCurrentOnboardingStepForUser(flow, metadata) {
    if (metadata.onboarding?.onboarded) {
        return types_1.OnboardingStep.enum.done;
    }
    return getCurrentOnboardingStep(flow, new Set(metadata.onboarding?.completedSteps ?? []));
}
function getOnboardingStepAsOrdinal(onboardingStep, flow) {
    if (onboardingStep === "uninitialized") {
        return -1;
    }
    return getOnboardingSteps(flow).indexOf(onboardingStep);
}
//# sourceMappingURL=flows.js.map